import React from 'react';
import { formatPrice } from '../../../utils';

const ProductDataTable = React.memo(({ 
  activeTypeTab, 
  filteredProducts, 
  isAdmin, 
  isSatisci, 
  isMontajci, 
  handleEdit, 
  setDeleteModal 
}) => {
  if (filteredProducts.length === 0) return null;

  return (
    <>
      {/* Masaüstü Tablo Görünümü */}
      <table className="product-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Ürün Adı</th>
            {(activeTypeTab === 'ahsapJaluzi') ? (
              <>
                <th>M. İpli (Fiyat)</th>
                <th>Kurdeleli (Fiyat)</th>
                <th>M. İpli Red. (Fiyat)</th>
                <th>Kur. Red. (Fiyat)</th>
              </>
            ) : activeTypeTab === 'rustik' ? null : (
              <th>Birim Fiyat</th>
            )}
            {(isAdmin || isSatisci) && !isMontajci && <th>İşlemler</th>}
          </tr>
        </thead>
        <tbody>
          {filteredProducts.map((product, index) => (
            <tr key={product.id}>
              <td className="row-num">{index + 1}</td>
              <td className="product-name">{product.name}</td>

              {(activeTypeTab === 'ahsapJaluzi') ? (
                <>
                  <td className="product-price">
                    {product.merdivenIpliFiyat > 0 ? <span className="price-badge">{formatPrice(product.merdivenIpliFiyat)} ₺</span> : <span className="no-cost">—</span>}
                  </td>
                  <td className="product-price">
                    {product.kurdeleliFiyat > 0 ? <span className="price-badge">{formatPrice(product.kurdeleliFiyat)} ₺</span> : <span className="no-cost">—</span>}
                  </td>
                  <td className="product-price">
                    {product.merdivenIpliReduktorluFiyat > 0 ? <span className="price-badge">{formatPrice(product.merdivenIpliReduktorluFiyat)} ₺</span> : <span className="no-cost">—</span>}
                  </td>
                  <td className="product-price">
                    {product.kurdelaliReduktorluFiyat > 0 ? <span className="price-badge">{formatPrice(product.kurdelaliReduktorluFiyat)} ₺</span> : <span className="no-cost">—</span>}
                  </td>
                </>
              ) : activeTypeTab === 'rustik' ? null : (
                <td className="product-price">
                  <span className="price-badge">{formatPrice(product.unitPrice)} ₺</span>
                </td>
              )}
              {(isAdmin || isSatisci) && !isMontajci && (
                <td className="product-actions">
                  <button className="btn-edit-product" onClick={() => handleEdit(product)} title="Düzenle">
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="btn-delete-product" onClick={() => setDeleteModal(product)} title="Sil">
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobil Kart Görünümü */}
      <div className="product-card-list">
        {filteredProducts.map((product, index) => (
          <div key={product.id} className="product-card">
            <div className="product-card-header">
              <span className="product-card-num">#{index + 1}</span>
              <span className="product-card-name">{product.name}</span>
              {(isAdmin || isSatisci) && !isMontajci && (
                <div className="product-actions">
                  <button className="btn-edit-product" onClick={() => handleEdit(product)} title="Düzenle">
                    <i className="fas fa-edit"></i>
                  </button>
                  <button className="btn-delete-product" onClick={() => setDeleteModal(product)} title="Sil">
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              )}
            </div>
            <div className="product-card-prices">
              {activeTypeTab === 'ahsapJaluzi' ? (
                <>
                  {product.merdivenIpliFiyat > 0 && <span className="price-badge">M.İpli: {formatPrice(product.merdivenIpliFiyat)} ₺</span>}
                  {product.kurdeleliFiyat > 0 && <span className="price-badge">Kurdeleli: {formatPrice(product.kurdeleliFiyat)} ₺</span>}
                </>
              ) : activeTypeTab === 'rustik' ? (
                <span className="product-card-type">Rustik Ürün</span>
              ) : (
                product.unitPrice > 0 && <span className="price-badge">Satış: {formatPrice(product.unitPrice)} ₺</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
});

export default ProductDataTable;
